import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { map, catchError } from 'rxjs/operators';
import { Message } from '@app/models/message';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MessageService {
    private subject = new Subject<any>();

    constructor(
        private httpClient: HttpClient
    ) { }

    //recuperation des messages pour un utilisateur
    getMessagesById(object) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}messages/read`, object)
            .pipe(
                map(res => res ? res.document.records as Message[] : []),
                catchError(this.handleError)
            );
    }

  // tous les messages
  getMessagesToManage() {
    return this.httpClient.get<any>(`${environment.apiEndPoint}messages/read_manage`)
        .pipe(
            map(res => res ? res.document.records as Message[] : []),
            catchError(this.handleError)
        );
  }

    //recuperation des messages non lus pour un utilisateur
    getUnreadMessagesByDestinataire(object) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}messages/unread`, object)
            .pipe(
                map(res => res ? res.document as any[] : []),
                catchError(this.handleError)
            );
    }
    
    //envoi de message
    createMessage(object) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}message/create`, object)
            .pipe(
                map(res => res),
                catchError(this.handleError)
            );
    }

    //mettre les messages à lus pour une proposition donnée
    updateMessagesStatusByProposition(object){
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}message/update`, object)
            .pipe(
                map(res => res),
                catchError(this.handleError)
            );
    }

    clearMessages() {
        this.subject.next(null);
    }

    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }

    private handleError(error: any): Promise<any> {
        let retour = error?.error?.message || error?.message || error;
        if(error?.error?.data) retour += '<br />'+error?.error?.data;
        return Promise.reject(retour);
    }
}